import { getEndpoint } from "@api-routes/endpoint";

const MS_NAME = "contacts";

export const putContactAddressApiRoute = (contactUuid: string, addressType: string) =>
    `${getEndpoint(MS_NAME)}contacts/${contactUuid}/addresses/${addressType}`;
